export const SET_CONTACT = "verifyAccount/SET_CONTACT";
